import { Box } from '@mui/material';
import { Radio } from 'components/ui/FormControls';
import React from 'react';

import { Paper } from '@mui/material';

export interface RadioWithContentProps {
    checked: boolean;
    disabled?: boolean;
    onChange: () => void;
    label: string;
    content: JSX.Element;
}

export const RadioWithContent = (props: RadioWithContentProps) => {
    const { checked, disabled, onChange, label, content } = props;

    return (
        <Box
            sx={{
                border: '1px solid',
                borderColor: checked ? 'primary.main' : 'divider',
                p: 2,
            }}
        >
            <Radio
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                value="v"
                label={label}
            />
            {checked && <Paper sx={{ mt: 2, p: 2 }}>{content}</Paper>}
        </Box>
    );
};

export default RadioWithContent;
